import { hubError } from '../../constants/errors';
var validation = function (values) {
    var errors = {};
    if (!(values === null || values === void 0 ? void 0 : values.hubIdOrigin)) {
        errors.hubIdOrigin = hubError;
    }
    if (!(values === null || values === void 0 ? void 0 : values.hubIdDestination)) {
        errors.hubIdDestination = hubError;
    }
    return errors;
};
export default validation;
//# sourceMappingURL=createOutboundConsolidation.js.map